import { render, staticRenderFns } from "./EcommerceMedal.vue?vue&type=template&id=c2f729a8&"
import script from "./EcommerceMedal.vue?vue&type=script&lang=js&"
export * from "./EcommerceMedal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports